import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Select } from '@ngxs/store';
import { ImageMetaData, InventoryItem } from 'remarketing-angular-library';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AnalyticsService, SaComponent } from 'smartauction-frontend-micro-library';
import { DetailsQueries } from 'src/sell/lib/details/queries/details.queries';
import { AsyncPipe } from '@angular/common';
import { GridCarouselToggleComponent, CarouselComponent, ImageGridComponent } from 'remarketing-ui-components-lib';

@Component({
    selector: 'app-auto-vision-carousel',
    templateUrl: './auto-vision-carousel.component.html',
    styleUrls: ['./auto-vision-carousel.component.scss'],
    imports: [GridCarouselToggleComponent, CarouselComponent, ImageGridComponent, AsyncPipe]
})
export class AutoVisionCarouselComponent extends SaComponent implements OnInit {
  @Select(DetailsQueries.images) images$: Observable<ImageMetaData[]>;

  slickAvailable = false;
  showImageGrid = false;

  inventoryItem: InventoryItem;

  autoVisionCarouselTranslations = {
    carouselData: '',
    gridCarouselData: '',
    imageGridTranslations: '',
    slickSlider: '',
    refreshPage: ''
  };

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly analyticsService: AnalyticsService
    ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
    this.isSlickAvailable();
  }

  isSlickAvailable() {
    try {
      this.slickAvailable = typeof (window as any).jQuery.fn.slick !== 'undefined';
    } catch (e) {
      this.slickAvailable = false;
    }
  }

  consumeAnalyticsEvent(analyticsPayload) {
    this.analyticsService.track(analyticsPayload.eventType, analyticsPayload.payload);
  }

  getTranslations() {
    const keyParams = {
      'UIComponents': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        translate => {
          this.autoVisionCarouselTranslations.carouselData = translate[0].carousel;
          this.autoVisionCarouselTranslations.gridCarouselData = translate[0].gridcarouselToggle;
          this.autoVisionCarouselTranslations.imageGridTranslations = translate[0].imageGrid;
        },
        error => {
          console.log(error);
        }
      );
  }
}
